import { Attribute } from './Attribute.js';

export const CONTACT_SN_ATTRIBUTE_TYPE = 'ContactSnAttribute';
export const CONTACT_SN_ATTRIBUTE_ID = 'contact_sn';

/**
 * @property {string} value
 * @property {boolean} isReadOnly
 */
export class ContactSnAttribute extends Attribute {
  constructor({ value, isReadOnly = false }) {
    super();
    this.value = value;
    this.isReadOnly = isReadOnly;
    this.type = CONTACT_SN_ATTRIBUTE_TYPE;
  }
}
